import { Injectable } from '@angular/core';
import {
 GetAllVotesEcolodgePayloadModel,
 GetAllVotesPayloadModel,
 getVoteFiltersModel,
} from '@models/comments';
import {
 AddToFavorite,
 HotelSummaryModel,
 ResposeGalleryRooms,
 SimilarHotelsModel,
 Vote,
} from '@models/hotel';
import { ComboRooms, RoomsApiModel } from '@models/room';
import { Observable } from 'rxjs';
import { BaseRepository } from './base.repository';

@Injectable()
export class PDPRepository extends BaseRepository {
 // let requestHeader = {
 //     params,
 //     observe: "response",
 //     responseType: "json",
 //     headers: new HttpHeaders({
 //       "Accept": "application/json"
 //     })
 //   }

 getHotelInfoSummary(
  cityName: string,
  hotelName: string,
  date: string,
  endDate: string,
  accommodation: string
 ) {
  const url =
   this.baseUrl +
   (accommodation == 'hotel'
    ? 'v1/hotelInfo/getHotelSummaryInfo'
    : 'v1/accomodation/getHotelSummaryInfo') +
   `?cityName=${cityName}&hotelName=${hotelName}&date=${date}&endDate=${endDate}&nights=2`;

  return this.getWithoutCache<HotelSummaryModel>(url);
 }

 getRooms(hotelId: number, startDate: string, endDate: string) {
  const url = this.baseUrl + 'v1/hotelInfo/hotelRooms';
  return this.post<RoomsApiModel>(url, { startDate, hotelId, endDate });
 }

 getVoteSection(hotelId: number) {
  const url = this.baseUrl + `hotelInfo/voteSection?id=${hotelId}`;
  // const options = hotelId ?
  //     { params: new HttpParams().set('id', hotelId) } : {};
  return this.getWithoutCache<Vote[]>(url);
 }

 getVoteFilters(hotelId: number) {
  //vote/GetAll
  const url = this.baseUrl + `v1/vote/GetVoteFilters?HotelId=${hotelId}`;
  return this.getWithoutCache<getVoteFiltersModel>(url);
 }

 getVotes(model: GetAllVotesPayloadModel) {
  //vote/GetAll
  let urlStringScores = '';
  model.voteScores.forEach((item) => {
   urlStringScores += `&voteScores=${item}`;
  });

  let urlStringeasons = '';
  model.voteSeasons.forEach((item) => {
   urlStringeasons += `&voteSeasons=${item}`;
  });

  let urlStringLabels = '';
  model.filterTexts.forEach((item) => {
   urlStringLabels += `&filterTexts=${item}`;
  });

  const url =
   this.baseUrl +
   `v1/vote/GetVotes?hotelId=${model.hotelId}&pageIndex=${model.pageIndex}&pageSize=${model.pageSize}&travelType=${model.travelType}&roomId=${model.roomId}${urlStringScores}${urlStringeasons}${urlStringLabels}`;
  return this.getWithoutCache<any>(url);
 }
 getVotesEcolodge(model: GetAllVotesEcolodgePayloadModel) {
  // let urlStringScores = '';
  // model.voteScores.forEach((item) => {
  //     urlStringScores += `&voteScores=${item}`;
  // });

  // let urlStringeasons = '';
  // model.voteSeasons.forEach((item) => {
  //     urlStringeasons += `&voteSeasons=${item}`;
  // });

  // let urlStringLabels = '';
  // model.filterTexts.forEach((item) => {
  //     urlStringLabels += `&filterTexts=${item}`;
  // });

  const url =
   this.baseUrl +
   `v1/accomodation/GetVotes?hotelId=${model.hotelId}&HouseId=${model.HouseId}&pageIndex=${model.PageIndex}&pageSize=${model.PageSize}&Type=${model.Type}`;
  return this.getWithoutCache<any>(url);
 }

 getSimilarHotels(hotelId: number, startDate: string, endDate: string, hotelPrice: number) {
  const url =
   this.baseUrl +
   `v1/hotelInfo/SimilarHotels?hotelId=${hotelId}&startDate=${startDate}&endDate=${endDate}&hotelPrice=${hotelPrice}`;
  return this.getWithoutCache<{
   CardHeaderPartial: any;
   Hotels: SimilarHotelsModel[];
  }>(url);
 }
 getOtherRooms(parentId: number, startDate: string, endDate: string, type: number) {
  const url =
   this.baseUrl +
   `v1/accomodation/OtherRooms?parentId=${parentId}&startDate=${startDate}&endDate=${endDate}&type=${type}`;
  return this.getWithoutCache<{
   CardHeaderPartial: any;
   Hotels: SimilarHotelsModel[];
  }>(url);
 }
 getSimilarAccommodation(
  hotelId: number,
  houseId: string,
  startDate: string,
  endDate: string,
  type: number
 ) {
  const url =
   this.baseUrl +
   `v1/accomodation/SimilarHotels?hotelId=${hotelId}&houseId=${houseId}&startDate=${startDate}&endDate=${endDate}&type=${type}`;
  return this.getWithoutCache<{
   CardHeaderPartial: any;
   Hotels: SimilarHotelsModel[];
  }>(url);
 }

 getGalleryInfo(hotelId: number = 249) {
  const url = this.baseUrl + `v1/hotelInfo/getHotelGallery?hotelId=${hotelId}`;
  return this.getWithoutCache<any>(url);
 }

 getRoomDetails(model: any) {
  //hotelinfo/roomDetails
  const url = this.baseUrl + 'hotelinfo/roomDetails';
  return this.post<ResposeGalleryRooms>(url, model);
 }

 addToFavorite(hotelId: number): Observable<AddToFavorite> {
  const url = `${this.baseUrl}UserProfile/ChangeFavorite`;
  return this.post<AddToFavorite>(url, { hotelId });
 }

 getReserveUUID(reserveData: Record<string, any>) {
  const url = this.baseUrl + `v1/booking/RequestBooking`;
  return this.post<any>(url, reserveData);
 }

 getCalenderDetails(
  range: { StartDate: string; EndDate: string },
  accommodationData: { hotelId: string; houseId: string; type: string },
  isFirstRequest: boolean = false
 ) {
  const url =
   this.baseUrl +
   `v1/accomodation/Calendar?startDate=${range.StartDate}&endDate=${range.EndDate}&hotelId=${accommodationData.hotelId}&houseId=${accommodationData.houseId}&Type=${accommodationData.type}&isFirstRequest=${isFirstRequest}`;
  return this.getWithoutCache<string[]>(url);
 }

 getProformaEcolodge(
  StartDate: string,
  EndDate: string,
  FixedGuestCount: string,
  ExtraGuestCount: string,
  HouseId: string,
  Type = '2'
 ) {
  const url =
   this.baseUrl +
   `v1/accomodation/proforma?StartDate=${StartDate}&endDate=${EndDate}&FixedGuestCount=${FixedGuestCount}&ExtraGuestCount=${ExtraGuestCount}&HouseId=${HouseId}&Type=${Type}`;
  return this.getWithoutCache<any>(url);
 }
}
